// menuConf.js
import {
  Category,
  Dashboard,
  EnergySavingsLeaf,
  Group,
  Landslide,
  MenuBookOutlined,
  Person,
  SensorsOutlined,
  Settings,
  WaterDrop,
} from "@mui/icons-material";
import { getRouterPaths } from "../../router/routerPaths";

export const getMenuItems = (userType) => {
  const routerPaths = getRouterPaths(userType);

  if (userType === "Admin") {
    return [
      {
        text: "Dashboard",
        icon: <Dashboard />,
        route: routerPaths.home,
      },
      {
        text: "Utenti",
        icon: <Group />,
        route: routerPaths.users,
      },
      {
        text: "Terreni",
        icon: <Landslide />,
        route: routerPaths.lands,
      },
      {
        text: "Lista Colture",
        icon: <EnergySavingsLeaf />,
        route: routerPaths.cultureList,
      },
      {
        text: "Tipologia Terreni",
        icon: <Category />,
        route: routerPaths.fieldsType,
      },
      {
        text: "Tipologia Irrigazione",
        icon: <WaterDrop />,
        route: routerPaths.irrigationType,
      },
      {
        text: "Settings",
        icon: <Settings />,
        route: routerPaths.settings,
      },
    ];
  } else {
    return [
      {
        text: "Dashboard",
        icon: <Dashboard />,
        route: routerPaths.home,
      },
      {
        text: "I miei terreni",
        icon: <Landslide />,
        route: routerPaths.userLands,
      },
      {
        text: "I miei strumenti",
        icon: <SensorsOutlined />,
        route: routerPaths.tools,
      },
      {
        text: "Taccuino di campo",
        icon: <MenuBookOutlined />,
        route: routerPaths.fieldNotebook,
      },
      {
        text: "Profilo",
        icon: <Person />,
        route: routerPaths.profile,
      },
      {
        text: "Settings",
        icon: <Settings />,
        route: routerPaths.settings,
      },
    ];
  }
};
